import { matchSorter } from 'match-sorter';
import { DateTime } from 'luxon';
import omitBy from 'lodash/omitBy';

export const applyFilters = (data = [], filters = {}) => {
    
    const matchers = buildMatchers(filters);

    return Object.keys(matchers)
        .reduce(
            (result, filterName) => matchers[filterName](result),
            data
        );
};

const opts = (keys) => ({ keys, sorter: d => d });

function buildMatchers (filters = { }) {
    let matchers = {
        filenumber: data => matchSorter(data, filters.filenumber, opts(['fileNumber'])),
        county: data => matchSorter(data, filters.county, opts(['county'])),
        ownerName: data => matchMultiple(data, filters.ownerName, ['ownerFirstName', 'ownerMiddleName', 'ownerLastName']),
        address: data => matchMultiple(data, filters.address, ['streetNumber','streetName', 'streetSuffix']),
        status: data => matchMultiSelect(data, filters.status, ['statusId']),
        submissionStart: data => backDate(data, DateTime.fromJSDate(filters.submissionStart), ['submitted']),
        submissionEnd: data => forwardDate(data, DateTime.fromJSDate(filters.submissionEnd), ['submitted'])
    };

    return omitBy(matchers, (_, key) => !filters[key]);
}

function matchMultiple(data, value, keys) {
    if (!value || !value.length)
        return data;

    const terms = value.split(' ');

    if (!terms)
        return data;
    
    return terms.reduceRight(
        (results, term) => matchSorter(results, term, opts(keys)),
        data
    );
}

function matchSelect(data, option, keys) {
    if (!option || !option.value)
        return data;

    const { value } = option;

    return matchSorter(data, value, opts(keys));
}

function matchMultiSelect(data, options, keys) {
    return options.reduce(
        (result, option) => [ ...result, ...matchSelect(data, option, keys) ],
        []
    );
}

function backDate(data, since, keys = [], includeInvalid = true) {
    if (!since || !since.isValid)
        return data;

    const _keys = keys.map(k => {
        return (item) => {
            const dateToCheck = DateTime.fromISO(item[k]);
            if (dateToCheck.isValid) {
                return dateToCheck.toISODate({ format: 'basic' }) >= since.toISODate({ format: 'basic' });
            } else {
                return includeInvalid;
            }
        };
    });
    
    return matchSorter(data, 'true', opts(_keys));
}

function forwardDate(data, date, keys = [], includeInvalid = true) {
    if (!date || !date.isValid)
        return data;

    const _keys = keys.map(k => {
        return (item) => {
            const dateToCheck = DateTime.fromISO(item[k]);
            if (dateToCheck.isValid) {
                return dateToCheck.toISODate({ format: 'basic' }) <= date.toISODate({ format: 'basic' });
            } else {
                return includeInvalid;
            }
        };
    });
    
    return matchSorter(data, 'true', opts(_keys));
}